import React from "react";
import { Field, FieldArray, ErrorMessage } from "formik";

export default function HigherEducationDetailsComponent() {
  const levels = [
    "PhD",
    "Masters",
    "Degree",
    "HND",
    "Diploma",
    "Certificate",
    "Other",
  ];

  return (
    <div
      className="col-12 my-0 rounded-3 p-4"
      style={{
        border: "1px solid #e9ecef",
        backgroundColor: "#fff",
      }}
    >
      <h4 className="fw-bold mb-4">Higher or Vocational Education</h4>
      <div className="alert alert-info">
        <p className="mb-0">
          Add details of your higher or vocational education. Include level,
          qualification, institute, and year of completion.
        </p>
        <em>Example:</em>
        <ul className="mb-0">
          <li>2022 - PhD in Management - University of Colombo</li>
          <li>2020 - MBA in Finance - University of Sri Jayewardenepura</li>
          <li>2018 - BSc in Computer Science - University of Moratuwa</li>
          <li>2016 - Diploma in Hospitality Management - KDU / Hotel School</li>
          <li>
            2015 - CIMA / Chartered Accountant - Institute of Chartered
            Accountants of Sri Lanka
          </li>
        </ul>
        <p className="mt-2">
          Press <strong>"Add Another"</strong> to add records.
        </p>
      </div>

      <FieldArray name="higherEducation">
        {({ push, remove, form }) => {
          const { values } = form;
          const records = values.higherEducation || [];

          return (
            <>
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "15%" }}>Level</th>
                    <th style={{ width: "25%" }}>Qualification</th>
                    <th style={{ width: "30%" }}>Institute</th>
                    <th style={{ width: "15%" }}>Year</th>
                    <th style={{ width: "10%" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((row, index) => (
                    <tr key={index}>
                      {/* Level Dropdown */}
                      <td>
                        <Field
                          as="select"
                          name={`higherEducation[${index}].level`}
                          className="form-select"
                        >
                          <option value="">Select Level</option>
                          {levels.map((lvl) => (
                            <option key={lvl} value={lvl}>
                              {lvl}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name={`higherEducation[${index}].level`}
                          component="div"
                          className="text-danger"
                        />
                      </td>

                      {/* Qualification */}
                      <td>
                        <Field
                          type="text"
                          name={`higherEducation[${index}].qualification`}
                          className="form-control"
                          placeholder="Ex: MSc in Computer Science"
                        />
                        <ErrorMessage
                          name={`higherEducation[${index}].qualification`}
                          component="div"
                          className="text-danger"
                        />
                      </td>

                      {/* Institute */}
                      <td>
                        <Field
                          type="text"
                          name={`higherEducation[${index}].institute`}
                          className="form-control"
                          placeholder="Ex: University of Colombo"
                        />
                        <ErrorMessage
                          name={`higherEducation[${index}].institute`}
                          component="div"
                          className="text-danger"
                        />
                      </td>

                      {/* Year */}
                      <td>
                        <Field
                          type="number"
                          name={`higherEducation[${index}].year`}
                          className="form-control"
                          placeholder="Ex: 2019"
                        />
                        <ErrorMessage
                          name={`higherEducation[${index}].year`}
                          component="div"
                          className="text-danger"
                        />
                      </td>

                      {/* Remove Button */}
                      <td className="d-flex justify-content-center align-items-center">
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button
                type="button"
                className="btn btn-secondary mb-3"
                onClick={() =>
                  push({
                    level: "",
                    qualification: "",
                    institute: "",
                    year: "",
                  })
                }
              >
                Add Another
              </button>
            </>
          );
        }}
      </FieldArray>
    </div>
  );
}
